// Generated by https://quicktype.io

export enum EPermission {
  //APPLICATION FORM PERMISSIONS
  CREATE_APPLICATION_FORM = 'CREATE_APPLICATION_FORM',
  READ_APPLICATION_FORM = 'READ_APPLICATION_FORM',
  LIST_APPLICATION_FORMS = 'LIST_APPLICATION_FORMS',
  UPDATE_APPLICATION_FORM = 'UPDATE_APPLICATION_FORM',
  ARCHIVE_APPLICATION_FORM = 'ARCHIVE_APPLICATION_FORM',
  LIST_APPLICATION_FORM_RESOURCES = 'LIST_APPLICATION_FORM_RESOURCES',
  UPDATE_APPLICATION_FORM_RESOURCES = 'UPDATE_APPLICATION_FORM_RESOURCES',
  READ_APPLICATION_FORM_DASHBOARD = 'READ_APPLICATION_FORM_DASHBOARD',

  //APPLICATION PERMISSIONS
  READ_APPLICATION = 'READ_APPLICATION',
  LIST_APPLICATIONS = 'LIST_APPLICATIONS',
  UPDATE_APPLICATION = 'UPDATE_APPLICATION',
  ARCHIVE_APPLICATION = 'ARCHIVE_APPLICATION',
}

export interface PermissionResponse {
  data: PermissionData;
}

export interface PermissionData {
  group: PGroup[];
}

export interface PGroup {
  name: string;
  privilege: Privilege[];
}

export interface Privilege {
  slug: string;
  name: string;
  allow: boolean;
  description?: string;
}

export type GroupedPermission = {
  [K in PermissionGroup]?: Privilege[];
};

export type PermissionGroup = 'Project' | 'Task' | 'Deliverable' | 'Mile Stone' | 'User' | 'Title' | 'Role' | 'name';

export interface PermissionCommons {
  of: string;
}
